import DeviceDetection from '../../ports-backend/DeviceDetection';
import DeviceOrientation from '../../ports-backend/DeviceOrientation';
import Scroll from '../../ports-backend/Scroll';
import Location from '../../ports-backend/Location';
import Window from '../../ports-backend/Window';
import Document from '../../ports-backend/Document';
import GameFrame from '../../ports-backend/GameFrame';
import Tracking from '../../ports-backend/Tracking';
import Cookie from '../../ports-backend/Cookie';
import MessageBus from '../../ports-backend/MessageBus';
import PostalKit from '../../ports-backend/PostalKit';
import Promotions from '../../ports-backend/Promotions';
import VisibilityChange from '../../ports-backend/VisibilityChange';
import UserAction from '../../ports-backend/UserAction';
import FullScreen from '../../ports-backend/FullScreen';
const portsMap = {
  DeviceDetection,
  DeviceOrientation,
  Scroll,
  Location,
  Window,
  Document,
  GameFrame,
  Tracking,
  Cookie,
  MessageBus,
  PostalKit,
  Promotions,
  VisibilityChange,
  UserAction,
  FullScreen,
};

export default portsMap;
